<template>
  <b-card>
    <div class="mb-2">
      <h4 class="text-2xl text-black ">
        <strong>Conversation Coin History</strong>
      </h4>
    </div>

    <b-row
      v-show="isLoadingCard"
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4"
    >
      <b-col>
        <b-skeleton-img class="rounded" />
      </b-col>
      <b-col>
        <b-skeleton-img class="rounded" />
      </b-col>
      <b-col>
        <b-skeleton-img class="rounded" />
      </b-col>
      <b-col>
        <b-skeleton-img class="rounded" />
      </b-col>
    </b-row>
    <div
      v-show="!isLoadingCard"
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4"
    >
      <b-card
        v-for="(item, index) in dataCard"
        :key="index"
        class="border"
      >
        <div class="grid gap-8">
          <div class="flex justify-between items-center font-semibold text-base leading-relaxed tracking-wide align-middle">
            <span class="!capitalize">{{ capitalizer(item.template_type) }}</span>
            <!-- <span class="text-[#F95031]">{{ item.total_message_sent }}</span> -->
          </div>
          <div class="flex items-center gap-1">
            <span class="text-[#333333] font-normal text-base leading-relaxed tracking-wide align-middle">IDR{{ IDRWithoutLbl(item.total_cost) }} ({{ item.total_message_sent }})</span>
          </div>
        </div>
      </b-card>
    </div>
    <div>
      <BOverlay
        :show="isLoading"
        spinner-variant="primary"
        variant="light"
        blur="0"
        opacity=".5"
        rounded="sm"
      >
        <BTable
          id="scroll"
          ref="scroll"
          :items="items"
          :fields="fieldsDetailBroadcastForBrandsTable"
          show-empty
          empty-text="Tidak ada data yang ditampilkan."
          responsive
          sticky-header="500px"
          class="mt-1"
          @scroll.native="handleScroll"
        >
          <template #cell(sended_at)="data">
            <div class="text-center">
              {{ data.item.phone_number }}
            </div>
            <div class="text-center text-sm text-[#666666]">
              {{ DAY_MONTH_YEAR(data.item.updated_at) }}
            </div>
          </template>
          <template #cell(status)="data">
            <div>
              <div
                :class="{'bg-[#FFEDED]': data.item.status === 'FAILED','bg-[#DCF3EB]': data.item.status === 'SUCCESS', 'bg-[#FFF2E2]': data.item.status === 'PENDING' || data.item.status === 'SENDING' }"
                class=" rounded-lg py-[4px]"
              >
                <div
                  :class="{'text-[#E31A1A]': data.item.status === 'FAILED', 'text-[#34A770]': data.item.status === 'SUCCESS', 'text-[#FBA63C]': data.item.status === 'PENDING' || data.item.status === 'SENDING' }"
                  class="text-center text-capitalize  font-[500]"
                >
                  {{ capitalizeWords(data.item.status) }}
                </div>
              </div>
            </div>
          </template>
          <template #cell(template_type)="data">
            <span>{{ capitalizer(data.item.template_type) }}</span>
          </template>
          <template #cell(cost)="data">
            <span class="text-primary">Rp{{ data.item.cost }}</span>
          </template>
        </BTable>
      </BOverlay>
    </div>
  </b-card>
</template>
<script>
import { IDRWithoutLbl } from '@/libs/currency'
import { DAY_MONTH_YEAR } from '@/libs/formatDate'
import { apiInfoBroadcastForBrand, apiGetDetailBroadcastForBrands } from './Broadcast/service/api.broadcast.service'
import { fieldsDetailBroadcastForBrandsTable, capitalizeWords } from './Broadcast/config'

export default {
  data() {
    return {
      isLoading: false,
      isLoadingCard: false,
      limit: 15,
      offset: 0,
      isLastData: false,
      dataCard: [],
      items: [],
      fieldsDetailBroadcastForBrandsTable,
      DAY_MONTH_YEAR,
      IDRWithoutLbl,
      capitalizeWords,
      idBroadcast: this.$route.params.id,
    }
  },
  mounted() {
    this.getInfoBroadcst()
    this.getHistoryBroadcast()
  },
  methods: {
    capitalizer(str) {
      return str
        .toLowerCase()
        .replace(/\b\w/g, char => char.toUpperCase())
    },
    handleScroll(event) {
      const { scrollTop, scrollHeight, clientHeight } = event.target
      if (scrollTop + clientHeight >= scrollHeight - 1) {
        this.getHistoryBroadcast()
      }
    },
    async getHistoryBroadcast() {
      if (this.isLoading || this.isLastData) return
      try {
        this.isLoading = true
        // Asumsikan apiGetDetailBroadcastForBrands mengembalikan objek dengan properti 'data'
        // yang berisi data sebenarnya atau null/undefined jika tidak ada.
        const response = await apiGetDetailBroadcastForBrands(this.idBroadcast, this.limit, this.offset)

        // Periksa apakah response.data ada dan response.data.data adalah array
        if (response && response.data && Array.isArray(response.data.data)) {
          if (response.data.data.length > 0) {
            this.items = [...this.items, ...response.data.data]
            this.offset = this.items.length
          }
          // Jika panjang data kurang dari limit, tandai sebagai data terakhir
          if (response.data.data.length < this.limit) {
            this.isLastData = true
          }
        } else {
          // Jika response.data atau response.data.data tidak ada atau bukan array,
          // anggap sebagai data terakhir dan tidak ada item baru.
          this.isLastData = true
          // Anda bisa memilih untuk tidak menampilkan error di sini jika data null adalah kasus yang valid
          // atau menampilkan pesan yang lebih spesifik jika diperlukan.
          // Contoh: console.log('Tidak ada data history broadcast baru atau format data tidak sesuai.');
        }
        this.isLoading = false
      } catch (error) { // Tambahkan parameter error untuk logging jika perlu
        // console.error('Error fetching history broadcast:', error); // Opsional: log error
        this.$toast_error({
          message: 'Gagal mengambil data history broadcast',
        })
        // Set isLoading ke false juga di catch block jika error terjadi di awal
        this.isLoading = false
      } finally {
        this.isLoading = false
      }
    },
    async getInfoBroadcst() {
      try {
        this.isLoadingCard = true
        const { data } = await apiInfoBroadcastForBrand(this.idBroadcast)
        this.dataCard = data.data
      } catch {
        this.$toast_error({
          message: 'Gagal mengambil data info broadcast',
        })
      } finally {
        this.isLoadingCard = false
      }
    },
  },
}
</script>
